export const VALIDATION_REG_EXP_COST_OF_KWH = /^(?!0*(\.0+)?$)(\d+|\d*\.\d+)$/
export const VALIDATION_REG_EXP_PAYMENT_DAY = /^(2[0-8]|1[0-9]|[1-9])$/
